import { SPACING_BLOCK_HEIGHT_MAP } from '@features/cms/constants/spacingBlockHeightMap';
import theme from '@styles/theme';
export default {
  spacingBlock: (backgroundColor: string, height: string | null) => ({
    background: backgroundColor || theme.rawColors.neutralWhite,
    height: height ? SPACING_BLOCK_HEIGHT_MAP[height] || `${height}px` : [0, 0, 0, '6.04166667vw'],
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  })
};